<template>
  <div>
    <ul class="top-info">
      <li class="text">
        <p class="title">MEMBERSHIP</p>
        <p>전남드래곤즈 회원탈퇴입니다.</p>
      </li>
    </ul>

    <div class="withdraw-page join-form">
      <ul class="input-div">
        <li class="title">아이디</li>
        <li>
          <input type="text" class="input-style" v-model="formData.id" disabled>
        </li>
      </ul>
      <ul class="input-div">
        <li class="title">성명</li>
        <li>
          <input type="text" class="input-style" v-model="formData.name" disabled>
        </li>
      </ul>
      <ul class="input-div">
        <li class="title">비밀번호 확인</li>
        <li>
          <input type="password" class="input-style" v-model="formData.pw" @keyup="inputCheck" placeholder="비밀번호를 입력하세요">
        </li>
      </ul>
      <ul class="input-div">
        <li class="title">비밀번호 재 입력</li>
        <li>
          <input type="password" class="input-style" v-model="formData.repw" @keyup="inputCheck" placeholder="비밀번호를 재 입력하세요">
        </li>
        <li class="msg-li">
          <p v-if="!isEmpty(pwdCheckErr)" :class="{check: !pwdCheckErr, err: pwdCheckErr}">
            {{pwdCheckErr ? '비밀번호가 불일치합니다. 다시 입력해주세요' : '비밀번호가 일치합니다.'}}
          </p>
        </li>
      </ul>
      <ul class="input-div">
        <li class="title">회원탈퇴 주의사항 동의</li>
        <li>
          <div class="text-area">
<pre>적립금/혜택(등급) 및 재 가입시 복구 불가
- 회원 탈퇴 시, 회원님 아이디에 등록된 적립금과 혜택(등급)에 관련 된 사항은 모두 소멸되어, 재 가입을 하더라도 복구되지 않습니다.
- 연간회원권(시즌권), 티켓구매 내역 등은 삭제가 되며, 재 가입 후 재 등록 절차가 불가능합니다.

1:1 상담 내용 삭제 불가
- 홈페이지 내 고객 상담 서비스에 등록 된 상담 내용(질문, 답변 내용)은 탈퇴 후에도 자동 삭제되지 않습니다.
- 고객 상담 서비스에 등록 된 상담 내용은 회원 만족도를 위해 활용되며, 개인정보는 활용되지 않습니다.</pre>
          </div>
        </li>
        <li class="info-agree">
          <input type="radio" name="allAgree" v-model="formData.adPush" :value="true" class="select-style">
          <label class="radio-label pr">동의</label>
          <input type="radio" name="allAgree" v-model="formData.adPush" :value="false" class="select-style" checked="checked">
          <label class="radio-label">미동의</label>
        </li>
      </ul>
      <div class="btn-div">
        <button class="login-btn" @click="withdrawFunc">회원탈퇴</button>
        <button class="retry-btn" @click="routerMove">나가기</button>
      </div>
    </div>
  </div>
</template>

<script>
import {isEmpty, isPwd} from '@/lib';

export default {
  name: 'Withdraw',
  data() {
    return {
      formData: {},
      pwdCheckErr: null,
    }
  },
  computed: {
    userInfo(){
      return this.$store.getters['getUserInfo'];
    }
  },
  created() {
    this.formData.id = this.userInfo.id;
    this.formData.name = this.userInfo.name;
  },
  mounted () {
  },
  methods: {
    isEmpty,
    async withdrawFunc() {
      if(!this.validityCheck()) {
        return false;
      }

      if(confirm('탈퇴 하시겠습니까?')) {
        const {data} = await this.$http.post('/account/unregister', {user_pw: this.formData.pw});
        // console.log(data);
        if(data.success) {
          alert('회원탈퇴가 완료되었습니다.');
          this.$store.dispatch('logout');
          this.$router.push({name: 'main'});
        }
      }
    },
    routerMove() {
      this.$router.push({name: 'main'});
    },
    inputCheck() {
      if(this.formData.pw !== this.formData.repw) {
        this.pwdCheckErr = true;
      }else {
        this.pwdCheckErr = false;
      }
    },
    validityCheck() {
      if(isEmpty(this.formData.pw) || isEmpty(this.formData.repw)) {
        alert('비빌번호를 입력하세요.');
        return false;
      }
      if(!isEmpty(this.formData.pw) && !isEmpty(this.formData.repw)) {
        if(this.formData.pw !== this.formData.repw) {
          alert('비빌번호가 일치하지 않습니다.');
          return false;
        }
      }
      if(!this.formData.adPush) {
        alert('회원탈퇴 주의사항 동의를 해주세요.');
        return false;
      }

      return true;
    }
  }
}
</script>
